import React, { Component } from 'react';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  GridModel,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import  { all_information, loadingShow } from '../../App';
import './style.css';
import Message from '../../utils/Message/Message';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { BsCheck2 } from 'react-icons/bs';
import { BiX } from 'react-icons/bi';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import moment from 'moment';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { FiChevronDown } from 'react-icons/fi';
import { AiOutlineCloudDownload } from 'react-icons/ai';

import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import {
  DatePickerComponent,
  DateRangePickerComponent,
} from '@syncfusion/ej2-react-calendars';
import { getTrainingSettings } from '../../services/Position/PositionServices';
import {
  addTrainingCertificates,
  deleteTrainingCertificates,
  editTrainingCertificates,
  getTrainingCertificates,
} from '../../services/TrainingCertificate/TrainingCertificateService';
import ResourceMaster from './ResourceMaster';
interface IState {
  tradePersonDetailData: Array<any>;
  training_categories: Array<any>;
  training_items: Array<any>;
  name: string;
  job_title: string;
  hideDialogOrder: boolean;
  dataTradePerson: Array<any>;
}
interface IProps {
  GridHeight?: any;
}
export default class TrainingAndCertification extends Component<
  IProps,
  IState
> {
  private tradePersonGrid: GridComponent;
  private training_certification_id: number = -1;
  private isAdd: boolean = true;
  private DDRMTrainingCategories: DropDownListComponent;
  private DDRMTrainingItems: DropDownListComponent;
  private isExpiredSwitch: any;
  private isAttachmentSwitch: any;
  private animationSettings: AnimationSettingsModel;
  private buttonsOrder: ButtonPropsModel[];
  public validationRule: Object = { required: true };
  private assignment_id: number = 0;
  private e_name: string = '';
  private isAttachment: boolean = false;
  private isExp: boolean = false;
  private notes: string = '';
  private status: boolean = false;
  private validFromDateP: DatePickerComponent;
  private validToDateP: DatePickerComponent;
  private tradePersonDetailGrid: GridComponent;
  private ids: Array<number> = [];
  constructor(props: IProps) {
    super(props);
    this.tradePersonGrid = new GridComponent(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };

    this.state = {
      tradePersonDetailData: [],
      training_categories: [],
      training_items: [],
      job_title: '',
      name: '',
      hideDialogOrder: false,
      dataTradePerson: [],
    };
    this.DDRMTrainingItems = new DropDownListComponent({});
    this.DDRMTrainingCategories = new DropDownListComponent({});
    this.buttonsOrder = [
      {
        click: () => {
          this.saveAddEdit();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogOrder: false });
        },
        buttonModel: {
          content: 'Done',
        },
      },
    ];
    this.validFromDateP = new DatePickerComponent({});
    this.validToDateP = new DatePickerComponent({});
    this.tradePersonDetailGrid = new GridComponent({});
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  // public toolbarOptions = [
  //   {
  //     text: 'Add',
  //     tooltipText: 'Add',
  //     prefixIcon: 'e-add',
  //     id: 'add',
  //   },
  //   {
  //     text: 'Edit',
  //     tooltipText: 'Edit',
  //     prefixIcon: 'e-edit',
  //     id: 'edit',
  //   },
  //   {
  //     text: 'Delete',
  //     tooltipText: 'Delete',
  //     prefixIcon: 'e-delete',
  //     id: 'delete',
  //   },
  //   {
  //     text: 'Refresh',
  //     tooltipText: 'Refresh',
  //     prefixIcon: 'e-repeat',
  //     id: 'refresh',
  //   },
  //   'ExcelExport',
  //   'ColumnChooser',
  //   'Search',
  // ];
  public editOptionsTradePersons: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  public pageOptionsTradePerson: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
  };
  saveAddEdit() {}
  deleteTrainingCert() {
    const obj = {
      ID: this.training_certification_id,
    };
    deleteTrainingCertificates(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getTrainingCertificate(this.ids);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addTrainingCert(objCommer: any) {
    var data = this.tradePersonGrid.getSelectedRecords() as any;
    var ids: Array<String> = [];
    if (!data) {
      Message.error('Must select a person.');
      objCommer.cancel = true;
      return;
    }
    var theDetail = data.map((el: any) => {
      ids.push(el.assignment_id);
      return {
        assignment_id: el.assignment_id,
        created_by: all_information.user_id,
        organization_id: all_information.company_id?.toString(),
        is_attachments: this.isAttachmentSwitch.checked,
        is_expiry_alert: this.isExpiredSwitch.checked,
        notes: objCommer.data.notes,
        valid_from_date: objCommer.data.valid_from_date,
        valid_to_date: objCommer.data.valid_to_date,
        training_item_id: this.DDRMTrainingItems.value,
        training_categori_id: this.DDRMTrainingCategories.value,
        training_certification_id: objCommer.data.training_certification_id,
        job_title: objCommer.data.job_title,
        status: objCommer.data.status,
      };
    });
    var theStartDate = new Date(objCommer.data.valid_from_date).getTime();
    var theEndDate = new Date(objCommer.data.valid_to_date).getTime();
    if (theEndDate < theStartDate) {
      Message.warning('End date cannot be past.');
      objCommer.cancel = true;
      loadingShow(false);
      return;
    }
    loadingShow(true, 'Adding');
    if (this.isAdd) {
      addTrainingCertificates(theDetail)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          if (this.tradePersonGrid.getSelectedRecords().length > 0) {
            this.getTrainingCertificate(ids);
          }
        })
        .catch((err) => {
          loadingShow(false);
          if (this.tradePersonGrid.getSelectedRecords().length > 0) {
            this.getTrainingCertificate(ids);
          }
        });
    } else {
      editTrainingCertificates(theDetail)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          loadingShow(false);
          if (this.tradePersonGrid.getSelectedRecords().length > 0) {
            this.getTrainingCertificate(ids);
          }
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  public select: any = {
    persistSelection: true,
    type: 'Multiple',
    checkboxOnly: true,
  };
  componentDidMount() {
    this.getTrainingCategories();
    this.getTrainingItems();
    $('.collapse-three').click(function () {
      $('.three').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement3').toggleClass('rotateIcon-event');
    });
  }
  getTrainingCertificate(ids: Array<any>) {
    loadingShow(true, 'Loading');
    if (ids.length === 0) {
      loadingShow(false);
      this.setState({ tradePersonDetailData: [] });
      return;
    }

    getTrainingCertificates(ids?.toString())
      .then((el) => {
        loadingShow(false);
        let theData = el.data.map((res: any) => {
          return {
            ...res,
            status: this.calculateStatus(res.valid_to_date, res.grace_period),
          };
        });
        this.setState({ tradePersonDetailData: theData });
      })
      .catch((e) => {
        loadingShow(false);
        //(e);
      });
  }

  getTrainingItems() {
    getTrainingSettings('item')
      .then((el) => {
        this.setState({ training_items: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getTrainingCategories() {
    getTrainingSettings('categorie')
      .then((el) => {
        this.setState({ training_categories: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  trainingCategoriesTemplate = (args: any) => {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.DDRMTrainingCategories = el;
        }}
        placeholder='Training Categories'
        text={args.training_categori_name}
        value={args.training_categori_id}
        style={{ height: 25 }}
        dataSource={this.state.training_categories}
        onChange={(e: any) => {
          var theData = this.state.training_items;
          let theSource = theData.filter((el) => {
            return Number(el.training_categori_id) === Number(e.value);
          });
          this.DDRMTrainingItems.dataSource = theSource;
        }}
        fields={{
          text: 'name',
          value: 'ID',
        }}
      />
    );
  };
  trainingItemsTemplate = (args: any) => {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.DDRMTrainingItems = el;
        }}
        placeholder='Training Categories'
        text={args.training_item_name}
        value={args.training_item_id}
        style={{ height: 25 }}
        dataSource={this.state.training_items}
        fields={{
          text: 'code',
          value: 'ID',
        }}
      />
    );
  };
  actionBeginTrainingCertification(args: any) {
    if (args.requestType === 'refresh') {
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addTrainingCert(args);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addTrainingCert(args);
    } else if (args.requestType === 'delete') {
      this.training_certification_id = args.data[0].ID;
      this.deleteTrainingCert();
    }
  }
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getTrainingCertificate(this.ids);
    }
  }
  toolbarTradePersonCertClick(args: any) {
    if (args.item.id === 'refresh') {
    }
    if (args.item.id === 'add') {
      var theSelectedGrid = this.tradePersonGrid.getSelectedRecords();
      if (theSelectedGrid.length > 0) {
        console.log(theSelectedGrid);
        this.setState({
          dataTradePerson: theSelectedGrid,
          hideDialogOrder: true,
        });
      } else {
        Message.error('Should select a row');
      }
    }
    if (args.item.id === 'edit') {
    }
  }
  public toolbarOptionsForTradeperson = [
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  private isExpirementTemplate = (args: any) => {
    let isComplete = args.is_expiry_alert;
    return (
      <div>
        {isComplete ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  private isExpirementTemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.is_expiry_alert}
        ref={(scope) => (this.isExpiredSwitch = scope)}
      />
    );
  };
  private isAtachmentTemplate = (args: any) => {
    let isComplete = args.is_attachments;
    return (
      <div>
        {isComplete ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  private isAtachmentTemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.is_attachments}
        ref={(scope) => (this.isAttachmentSwitch = scope)}
      />
    );
  };
  calculateStatus(valid_to_date: any, grace_per: number) {
    var current_date = new Date().getTime();
    var to_date = new Date(valid_to_date).getTime();
    var the_grace_per = grace_per * 86400000;
    if (current_date > to_date) {
      return 0;
    } else if (
      current_date >= to_date - the_grace_per &&
      current_date < to_date
    ) {
      return 1;
    } else {
      return 2;
    }
  }
  private employeNameTemp = () => {
    return <TextBoxComponent enabled={false} placeholder={this.state.name} />;
  };
  private statusTemp = () => {
    return <TextBoxComponent enabled={false} placeholder={this.state.name} />;
  };
  statusTemplate(args: any) {
    const val = args.status;
    let color = '';
    let textColor = '';
    let text = '';
    if (val === 0) {
      color = '#C90016';
      text = 'INACTIVE';
      textColor = 'red';
    } else if (val === 1) {
      color = '#FFCA2C';
      text = 'WARNING';
      textColor = 'black';
    } else if (val === 2) {
      color = '#339933';
      textColor = 'green';
    }
    return (
      <div
        style={{
          backgroundColor: color,
          padding: '5px',
          textAlign: 'center',
          color: textColor,
          borderRadius: '5px',
          width: '30px',
          height: '30px',
        }}
      ></div>
    );
  }
  private row_selected(args: any) {
    this.setState({
      name: args.data.full_name,
      job_title: args.data.job_title,
    });
    this.assignment_id = args.data.assignment_id;
    var index = this.ids.findIndex((el) => {
      return el === this.assignment_id;
    });
    if (index === -1) {
      this.ids.push(this.assignment_id);
    }
    this.getTrainingCertificate(this.ids);
  }
  private row_deselected(args: any) {
    this.setState({ name: '', job_title: '' });
    this.assignment_id = args.data.assignment_id;
    var index = this.ids.findIndex((el) => {
      return el === this.assignment_id;
    });
    if (index !== -1) {
      this.ids.splice(index, 1);
    }
    this.getTrainingCertificate(this.ids);
  }
  validFromTemp(args: any) {
    return (
      <div>
        <span>{moment(args.valid_from_date).format('DD/MM/yyyy')}</span>
      </div>
    );
  }
  validToTemp(args: any) {
    return (
      <div>
        <span>{moment(args.valid_to_date).format('DD/MM/yyyy')}</span>
      </div>
    );
  }
  startDateTemp(args: any) {
    return (
      <div>
        <span>{moment(args.emp_start_date).format('DD/MM/yyyy')}</span>
      </div>
    );
  }
  endDateTemp(args: any) {
    return (
      <div>
        <span>{moment(args.emp_end_date).format('DD/MM/yyyy')}</span>
      </div>
    );
  }
  templateCertifica(args: any) {
    let is_attachments = args.is_attachments;
    let items = [
      'https://dl.dropboxusercontent.com/s/9jl1xf1k1n27j4y/certifaction%20sample3.pdf?dl=0',
      'https://dl.dropboxusercontent.com/s/8nzqn86t7hi0fvg/certicate%20sample.pdf?dl=0',
      'https://dl.dropboxusercontent.com/s/p9nh6xfsjldbhok/certifaction%20sample2.pdf?dl=0',
    ];
    let path = this.random_item(items);
    return (
      <div>
        {is_attachments ? (
          <a href={path}>
            <AiOutlineCloudDownload size={25} color='blue' />
          </a>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
  random_item(items: any) {
    return items[Math.floor(Math.random() * items.length)];
  }
  templateCertificaEditing(args: any) {
    return <TextBoxComponent enabled={false} placeholder={'certifica'} />;
  }
  render() {
    return (
      <div className='tac-wrapper'>
        <div className='tac-wrapper-tradeperson'>
          <ResourceMaster
            gridRef={(theGrid: GridComponent) =>
              (this.tradePersonGrid = theGrid)
            }
            onGridSelected={this.row_selected.bind(this)}
            onGridDeSelected={this.row_deselected.bind(this)}
            allowMultiSelectection={true}
            height='calc(-220.6px + 50vh)'
          />
        </div>
        <div className='collapse-parent-div '>
          <div className='collapse-sub-flex collapse-three'>
            <div className='collapse-icon-div-three collapse-flex'>
              <FiChevronDown id='rotate-icon-eventmanagement3' size={17} />
            </div>
          </div>
          <div className='three'>
            <GridComponent
              id='training_sdflskdflmllmsdfsdfrefsdcsd'
              toolbar={this.toolbarOptions}
              dataSource={this.state.tradePersonDetailData}
              editSettings={this.editOptionsTradePersons}
              height='calc(-220.6px + 50vh)'
              ref={(theGrid: GridComponent) =>
                (this.tradePersonDetailGrid = theGrid)
              }
              toolbarClick={this.toolbarTradePersonCertClick.bind(this)}
              filterSettings={this.FilterOptions}
              actionBegin={this.actionBeginTrainingCertification.bind(this)}
              allowFiltering={true}
              allowExcelExport
              allowPaging={true}
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={true}
              gridLines='Both'
            >
              <ColumnsDirective>
                <ColumnDirective
                  field='EmployeeName'
                  headerText='Employe name'
                  textAlign='Left'
                  editTemplate={this.employeNameTemp}
                />
                <ColumnDirective
                  field='training_categori_name'
                  headerText='Training Category '
                  textAlign='Left'
                  editTemplate={this.trainingCategoriesTemplate}
                />
                <ColumnDirective
                  field='training_item_name'
                  headerText='Training Item '
                  textAlign='Left'
                  editTemplate={this.trainingItemsTemplate}
                />
                <ColumnDirective
                  field='is_attachments'
                  headerText='Attachment'
                  textAlign='Left'
                  template={this.isAtachmentTemplate}
                  editTemplate={this.isAtachmentTemplateEditing}
                />
                <ColumnDirective
                  headerText='#'
                  textAlign='Left'
                  template={this.templateCertifica.bind(this)}
                  editTemplate={this.templateCertificaEditing.bind(this)}
                  width={70}
                />
                <ColumnDirective
                  field='is_expiry_alert'
                  headerText='Expiry Alert'
                  textAlign='Left'
                  editType='datepickeredit'
                  template={this.isExpirementTemplate}
                  editTemplate={this.isExpirementTemplateEditing}
                />
                <ColumnDirective
                  field='valid_from_date'
                  headerText='Valid From'
                  textAlign='Left'
                  editType='datepickeredit'
                  template={this.validFromTemp.bind(this)}
                />
                <ColumnDirective
                  field='valid_to_date'
                  headerText='Valid To'
                  textAlign='Left'
                  template={this.validToTemp.bind(this)}
                  editType='datepickeredit'
                />
                <ColumnDirective
                  field='notes'
                  headerText='Notes'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='status'
                  headerText='Status'
                  textAlign='Center'
                  template={this.statusTemplate.bind(this)}
                  editTemplate={this.statusTemp}
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Toolbar,
                  Filter,
                  ColumnChooser,
                  ExcelExport,
                  Page,
                  ColumnMenu,
                  Resize,
                  Group
                ]}
              />
            </GridComponent>
          </div>
        </div>
        {this.state.hideDialogOrder ? (
          <DialogComponent
            isModal={true}
            id='defaultdialogControlCenterPlanOrder'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideDialogOrder}
            header='Work Orders'
            buttons={this.buttonsOrder}
            open={() => {
              this.setState({ hideDialogOrder: true });
            }}
            close={() => {
              this.setState({ hideDialogOrder: false });
            }}
            width={window.innerWidth - 150}
          >
            <div className='row'>
              <div className='col-md-12'>
                <div className='col-md-2'>
                  <TextBoxComponent
                    placeholder='Employee Name'
                    floatLabelType='Auto'
                    value={this.e_name}
                    onChange={(el: any) => {
                      this.e_name = el.value;
                    }}
                  />
                </div>
                <div className='col-md-2'>
                  <DropDownListComponent
                    ref={(el: DropDownListComponent) => {
                      this.DDRMTrainingCategories = el;
                    }}
                    placeholder='Training Categories'
                    // text={args.training_categori_name}
                    // value={args.training_categori_id}
                    style={{ height: 25 }}
                    dataSource={this.state.training_categories}
                    onChange={(e: any) => {
                      var theData = this.state.training_items;
                      let theSource = theData.filter((el) => {
                        return (
                          Number(el.training_categori_id) === Number(e.value)
                        );
                      });
                      this.DDRMTrainingItems.dataSource = theSource;
                    }}
                    floatLabelType='Auto'
                    fields={{
                      text: 'name',
                      value: 'ID',
                    }}
                  />
                </div>
                <div className='col-md-2'>
                  <DropDownListComponent
                    ref={(el: DropDownListComponent) => {
                      this.DDRMTrainingItems = el;
                    }}
                    placeholder='Training Categories'
                    // text={args.training_item_name}
                    // value={args.training_item_id}
                    style={{ height: 25 }}
                    floatLabelType='Auto'
                    fields={{
                      text: 'code',
                      value: 'ID',
                    }}
                  />
                </div>
                <div className='col-md-2'>
                  <DateRangePickerComponent
                    cssClass='customCSS '
                    id='daterangepickerTrainingCertifications'
                    format={'dd/MM/yyyy'}
                    floatLabelType='Auto'
                    placeholder='Valid Date'
                    // value={this.DateRangeValue}
                  />
                </div>
                <div className='col-md-2'>
                  {/* <DatePickerComponent
                    id='plannedStart'
                    style={{ height: 25 }}
                    placeholder='Valid To'
                    floatLabelType='Auto'
                    format={'dd/MM/yyyy'}
                    ref={(el: DatePickerComponent) => this.validToDateP}
                    // value={this.planned_start_date}
                    // onChange={(e: any) => {
                    //   this.planned_start_date = e.target.value;
                    // }}
                  /> */}
                </div>
                <div className='col-md-2'>
                  <TextBoxComponent
                    placeholder='Notes'
                    floatLabelType='Auto'
                    value={this.notes}
                    onChange={(e: any) => {
                      this.notes = e.value;
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='col-md-2' style={{ marginTop: 10 }}>
                  <div className='col-md-8'>Attachtment</div>
                  <div className='col-md-4'>
                    <SwitchComponent
                      change={(e: any) => {
                        this.isAttachment = e.checked;
                      }}
                      checked={this.isAttachment}
                    />
                  </div>
                </div>
                <div className='col-md-2' style={{ marginTop: 10 }}>
                  <div className='col-md-8'>Expiry Alert</div>
                  <div className='col-md-4'>
                    <SwitchComponent
                      change={(e: any) => {
                        this.isExp = e.checked;
                      }}
                      checked={this.isExp}
                    />
                  </div>
                </div>
                {/* <div className='col-md-12'>
                  <div className='col-md-7'>Status</div>
                  <div className='col-md-5'>
                    <SwitchComponent
                      id='swichActiveOrInActive'
                      cssClass='handle-color'
                      change={(e: any) => {
                        this.status = e.checked;
                      }}
                      checked={this.status}
                    />
                  </div>
                </div> */}
              </div>
            </div>

            <div className='row'>
              <GridComponent
                id='gridPlanWorkOrder'
                dataSource={this.state.dataTradePerson}
                filterSettings={this.FilterOptions}
                allowFiltering={true}
                allowPaging={true}
                pageSettings={this.pageOptions}
                showColumnMenu={true}
                allowResizing={true}
                allowReordering={true}
                allowSelection={true}
                selectionSettings={this.select}
                allowGrouping={true}
                style={{ marginTop: '10px' }}
                gridLines='Both'
                width={window.innerWidth - 150}
                // rowSelected={this.rowselect.bind(this)}
                height='25vh'
                dataBound={() => {
                  var searchEle = this.tradePersonGrid.element.querySelector(
                    '#' + this.tradePersonGrid.element.id + '_searchbar'
                  );
                  if (searchEle) {
                    searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
                  }
                }}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    type='checkbox'
                    allowSorting={false}
                    allowFiltering={false}
                    width='60'
                  />
                  <ColumnDirective
                    field='first_name'
                    headerText='First name'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='middle_name'
                    headerText='Middle name'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='last_name'
                    headerText='Last Name'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='alias_name'
                    headerText='Alias Name'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='position_name'
                    headerText='Position'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='department_code'
                    headerText='Department'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='manager'
                    headerText='Manager'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='site_assigned'
                    headerText='Site Asigned'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='emp_start_date'
                    headerText='Start Date'
                    textAlign='Left'
                    template={this.validFromDateP}
                  />
                  <ColumnDirective
                    field='emp_end_date'
                    headerText='End Date'
                    textAlign='Left'
                    template={this.validToDateP}
                  />
                  <ColumnDirective
                    field='email'
                    headerText='Email'
                    textAlign='Left'
                  />
                  <ColumnDirective
                    field='contact_number'
                    headerText='Contact Number'
                    textAlign='Left'
                  />
                </ColumnsDirective>
                <Inject services={[Edit, Toolbar, Page]} />
              </GridComponent>
            </div>
          </DialogComponent>
        ) : null}
      </div>
    );
  }
}
